import endpoints, { axios } from "../config/api";

function getTaskTemplateSubtasks(templateId: number, page: number = 1) {
  return axios.get(endpoints.taskTemplates.getSubtasks(templateId, page));
}

export default getTaskTemplateSubtasks;
